var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('li',[_c('router-link',{class:{ 'is-active': _vm.active },attrs:{"to":_vm.to}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t(_vm.label)))]})],2)],1):_c('li',[_vm._v("\n  "+_vm._s(_vm.$t(_vm.label))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }